import React from "react";
import Head from "next/head";
import { URL_CATCH_LOGO_SEO } from "@catchoftheday/common-vendors";
import { cleanHostName } from "@catchoftheday/utilities";
export const SEO = ({ host }) => {
    const prettyDomain = host && cleanHostName(host, true);
    return (<Head>
      <title>
        Transfer your OnePass subscription for access to all participating
        brands
        {prettyDomain ? ` | ${prettyDomain}` : ""}
      </title>
      <meta name="description" content="The OnePass membership provider is changing from Catch to Wesfarmers to bring you more benefits. Follow the steps to securely transfer your subscription to the new OnePass."/>
      <meta property="og:type" content="website"/>
      <meta property="og:site_name" content={prettyDomain}/>
      <meta property="og:image" content={URL_CATCH_LOGO_SEO}/>
      <meta property="og:locale" content="en_AU"/>
    </Head>);
};
